import React from 'react'
import PMELogo from '../assets/images/pme-logo.svg'

class Header extends React.Component {
  render() {
    return (
      <section id="header">
        <div className="ellipse"></div>
        <div className="innerEllipse"></div>
        <div className="inner">
          <a href="/"><img src={PMELogo} id="pme-logo" title="Home" /></a>
        </div>
      </section>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js